export const TIPO_INMOVILIZADO = {
  MATERIAL: 1,
  INTANGIBLE: 2,
} as const

export type TipoInmovilizadoType =
  (typeof TIPO_INMOVILIZADO)[keyof typeof TIPO_INMOVILIZADO]
